export enum AnalyticsEvents {
  /* Recommended GA events */
  AppOpen = 'app_open',
  Login = 'login',
  Logout = 'logout',
  PageView = 'screen_view',

  /* Custom events */
  UI_interaction = 'ui_interaction', // Metrics: type, action, name, sub_name
  Notification = 'notification', // Metrics: type, name, action
  Process = 'process', // Metrics: name, step
  ProcessCompleted = 'process_completed', // Metrics: name
}